import { IconSocialInstagram24 } from '@cian/ui-kit-design-tokens/icons';

import { type ReactNode } from 'react';

import { type Pessimization, PessimizationOverlay } from '../PessimizationOverlay';

type StubProps = {
  pessimization?: Pessimization;
};

export function Stub({ pessimization }: StubProps): ReactNode {
  return (
    <div className="wrapper">
      <PessimizationOverlay pessimization={pessimization}>
        <div className="placeholder">
          <IconSocialInstagram24 color="gray60_100" />
        </div>
      </PessimizationOverlay>
    </div>
  );
}
